import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { WidgetContentService } from '../../widget-content.service';
import { WidgetPlaceHolderControlModel } from '@fi-shared/widget/widget-place-holder-control.model';
import { IWidgetSettingsModel } from '@fi-shared/widget/widget-settings.model';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { WidgetSharedService } from '@fi-shared/widget/widget-shared.service';
import { FiTextItemHelperService } from '@fi-shared/fi-text-item-helper/fi-text-item-helper.service';

@Component({
    selector: 'fi-widget-content-advanced-text',
    templateUrl: './advanced-text.component.html',
    styleUrls: ['./advanced-text.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-widget-content-advanced-text', '(click)': 'onClick($event)' },
    standalone: false,
})
export class WidgetContentAdvancedTextComponent implements OnInit, OnDestroy {
    @Input() settings: IWidgetSettingsModel;
    @Input() control: WidgetPlaceHolderControlModel;
    @Input() languageId: number;

    constructor(
        private widgetContentService: WidgetContentService,
        private widgetSharedService: WidgetSharedService,
        private fiTextItemHelperService: FiTextItemHelperService,
    ) {}

    ngOnInit(): void {
        this._isEmpty$.next(!this.GetContent());

        this.widgetSharedService
            .getWidgetSettingsChanged$(() => this.settings)
            .pipe(takeUntil(this.ngOnDestroy$))
            .subscribe(() => {
                this._isEmpty$.next(!this.GetContent());
            });
    }

    onClick($event: MouseEvent) {
        this.fiTextItemHelperService.onTextItemClick($event, this.control.MediaBankFileReferences);
    }

    GetContent() {
        return this.getContentWithLanguage(this.settings.Contents);
    }

    getContentWithLanguage(Contents) {
        return this.widgetContentService.getContentWithLanguage(Contents, this.languageId);
    }

    GetHeaderTitle() {
        return this.widgetContentService.GetHeaderTitle(this.control, this.languageId);
    }

    private _isEmpty$ = new BehaviorSubject<boolean>(true);
    get isEmpty$() {
        return this._isEmpty$.asObservable();
    }

    private ngOnDestroy$ = new Subject<void>();
    ngOnDestroy(): void {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }
}
